exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".results-table thead tr{vertical-align:bottom}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/ResultsTable/ResultsTable.less
 ** module id = 1067
 ** module chunks = 0
 **/